export { default } from './PaginationItem';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/PaginationItem/index.js
// module id = 571
// module chunks = 2